module.exports = __webpack_public_path__ + "dd9a812e3b08b02640c5d819c459bf57.svg";